import { connect } from 'react-redux';
import { push } from 'redux-first-history';

import LandingPage from './component';
import OnboardingStatus from '@renter-hub/constants/onboardingStatus';
import paths from '@renter-hub/pathsManifest';
import { getSignInPage } from '@common/paymentsUtils/api';

const mapStateToProps = (state) => {
  const { onboardingStatus, paymentReporting } = state.payments.renter.dashboard;
  const enableContinueToOnboarding =
    onboardingStatus === OnboardingStatus.REGISTERED ||
    onboardingStatus === OnboardingStatus.NO_EXTERNAL_ACCOUNT_FOUND ||
    onboardingStatus === OnboardingStatus.ON_HOLD ||
    onboardingStatus === OnboardingStatus.REJECTED;
  return {
    onboardingStatus,
    enableContinueToOnboarding,
    paymentReportingOptedIn: paymentReporting?.optedIn,
    featureFlagEnableRentReporting: state.payments.renter.dashboard.enableCreditReporting,
  };
};

const mapDispatchToProps = (dispatch, { baseUrl }) => ({
  goToSignInPage: () => {
    window.location = getSignInPage();
    return null;
  },
  continueToOnboarding: (onboardingStatus) => {
    if (
      onboardingStatus === OnboardingStatus.REGISTERED ||
      onboardingStatus === OnboardingStatus.NO_EXTERNAL_ACCOUNT_FOUND
    ) {
      return dispatch(push(baseUrl + paths.paymentInfoPage));
    } else if (onboardingStatus === OnboardingStatus.ON_HOLD || onboardingStatus === OnboardingStatus.REJECTED) {
      window.location.href = '/rental/your-rental';
      return null;
    }
    return dispatch(push(baseUrl + paths.paymentSettingsPage));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(LandingPage);
